export const DefaultPaginationConfig = {
  current: 1,
  limit: 30,
  offset: 0,
  totalPages: 0,
};
